<template>
			<div class="content">
		        <div class="container-fluid">
		        	<div class="row">
			            <div class="col-md-12" v-if="data.params.user != null">
			              <div class="card">
			                <div class="card-header card-header-info">
			                  <h4 class="card-title ">Rincian Pembayaran</h4>
							</div>
			                <div class="card-body">
			                    <div class="row">
			                      <div class="col-md-2">
			                        <div class="form-group">
			                          <label class="bmd-label-floating">Nama Pelanggan</label>
			                        </div>
			                      </div>
			                      <div class="col-md-10 border-bottom">
			                        <div class="form-group">
			                          <label class="bmd-label-floating">: <span>{{data.namaPelanggan}}</span></label>
			                        </div>
			                      </div>
			                    </div>
			                    <div class="row">
			                      <div class="col-md-2">
			                        <div class="form-group">
			                          <label class="bmd-label-floating">Kontak</label>
			                        </div>
			                      </div>
			                      <div class="col-md-10 border-bottom">
			                        <div class="form-group">
			                          <label class="bmd-label-floating">: <span v-text="data.telapon"></span></label>
			                        </div>
			                      </div>
			                    </div>
			                    <div class="row">
			                      <div class="col-md-2">
			                        <div class="form-group">
			                          <label class="bmd-label-floating">Bulan Bayar</label>
			                        </div>
			                      </div>
			                      <div class="col-md-10 border-bottom">
			                        <div class="form-group">
			                          <label class="bmd-label-floating">: <span>{{myGlobal.BulanOnly(data.bulanBayar)}}</span></label>
			                        </div>
			                      </div>
			                    </div>
			                    <div class="row">
			                      <div class="col-md-2">
			                        <div class="form-group">
			                          <label class="bmd-label-floating">Tanggal Bayar</label>
			                        </div>
			                      </div>
			                      <div class="col-md-10 border-bottom">
			                        <div class="form-group">
			                          <label class="bmd-label-floating">: <span>{{myGlobal.tglIndo(data.tglBayar)}}</span></label>
			                        </div>
			                      </div>
			                    </div>
			                    <div class="row">
			                      <div class="col-md-2">
			                        <div class="form-group">
			                          <label class="bmd-label-floating">Paket</label>
			                        </div>
			                      </div>
			                      <div class="col-md-10 border-bottom">
			                        <div class="form-group">
			                          <label class="bmd-label-floating">: <span v-text="data.paketPelanggan"></span></label>
			                        </div>
			                      </div>
			                    </div> 
			                    <div class="row">
			                      <div class="col-md-2">
			                        <div class="form-group">
			                          <label class="bmd-label-floating">Paket Tarif</label>
			                        </div>
			                      </div>
			                      <div class="col-md-10 border-bottom">
			                        <div class="form-group">
			                          <label class="bmd-label-floating">: <span>{{myGlobal.ribu(data.tarifPelanggan)}}</span></label>
			                        </div>
			                      </div>
			                    </div> 

			                    <div class="row">
			                      <div class="col-md-2">
			                        <div class="form-group">
			                          <label class="bmd-label-floating">Total Bayar</label>
			                        </div>
			                      </div>
			                      <div class="col-md-10 border-bottom">
			                        <div class="form-group">
			                          <label class="bmd-label-floating">: <span>{{myGlobal.ribu(data.totalBayar)}}</span></label>
			                        </div>
			                      </div>
			                    </div>

			                    <div class="row">
			                      <div class="col-md-2">
			                        <div class="form-group">
			                          <label class="bmd-label-floating">PPN</label>
			                        </div>
			                      </div>
			                      <div class="col-md-10 border-bottom">
			                        <div class="form-group">
			                          <label class="bmd-label-floating">: <span>{{myGlobal.ribu(data.params.user.ppn)}}</span></label>
			                        </div>
			                      </div>
			                    </div>

			                    <div class="row">
			                      <div class="col-md-2">
			                        <div class="form-group">
			                          <label class="bmd-label-floating">Area</label>
			                        </div>
			                      </div>
			                      <div class="col-md-10 border-bottom">
			                        <div class="form-group">
			                          <label class="bmd-label-floating">: <span v-text="data.params.area"></span></label>
			                        </div>
			                      </div>
			                    </div>

			                    <div class="row">
			                      <div class="col-md-2">
			                        <div class="form-group">
			                          <label class="bmd-label-floating">Biaya Tambahan 1</label>
			                        </div>
			                      </div>
			                      <div class="col-md-10 border-bottom">
			                        <div class="form-group">
			                          <label class="bmd-label-floating">: <span v-text="data.RincianTambahan1"></span></label></br>
			                          <label class="bmd-label-floating">: <span>{{myGlobal.ribu(data.BiayaTambahan1)}}</span></label>
			                        </div>
			                      </div>
			                    </div>

			                    <div class="row">
			                      <div class="col-md-2">
			                        <div class="form-group">
			                          <label class="bmd-label-floating">Biaya Tambahan 2</label>
			                        </div>
			                      </div>
			                      <div class="col-md-10 border-bottom">
			                        <div class="form-group">
			                          <label class="bmd-label-floating">: <span v-text="data.RincianTambahan2"></span></label></br>
			                          <label class="bmd-label-floating">: <span>{{myGlobal.ribu(data.BiayaTambahan2)}}</span></label>
			                        </div>
			                      </div>
			                    </div>

			                    <div class="row">
			                      <div class="col-md-2">
			                        <div class="form-group">
			                          <label class="bmd-label-floating">Diskon</label>
			                        </div>
			                      </div>
			                      <div class="col-md-10 border-bottom">
			                        <div class="form-group">
			                          <label class="bmd-label-floating">: <span>{{myGlobal.ribu(data.diskon)}}</span></label>
			                        </div>
			                      </div>
			                    </div>

			                    <div class="row">
			                      <div class="col-md-2">
			                        <div class="form-group">
			                          <label class="bmd-label-floating">Admin By</label>
			                        </div>
			                      </div>
			                      <div class="col-md-10 border-bottom">
			                        <div class="form-group">
			                          <label class="bmd-label-floating">: <span v-text="data.admin"></span></label>
			                        </div>
			                      </div>
			                    </div>
			                    <div class="row">
			                      <div class="col-md-2">
			                        <div class="form-group">
			                          <label class="bmd-label-floating">Aksi</label>
			                        </div>
			                      </div>
			                      <div class="col-md-10 border-bottom">
			                        <div class="form-group">
			                        	<button class="btn btn-md btn-info" @click="modal.modalBayarFunc">Print Ulang Nota</button>
			                        </div>
			                      </div>
			                    </div>
			                </div>
			              </div>
			            </div>
		        	</div>
		        	
		        	<div class="row" v-show="false"> <!-- v-if="data != null" -->
			            <div class="col-md-12">
			              <div class="card">
			                <div class="card-header card-header-info">
			                  <h4 class="card-title ">History Pembayaran</h4>
							</div>
			                <div class="card-body">
								<div class="table-responsive">
									<table class="table">
										<thead class=" text-info">
											<th width="30px">No.</th>
											<th>Paket</th>
											<th>Tarif</th>
											<th>Tagihan Bulan</th>
											<th>Aksi</th>
										</thead>
										<tbody v-if="data.datae.length != 0">
										<tr v-for="(ser, index) in data.datae">
											<td>{{ index+1 }}</td>
											<td>{{ ser.paket }}</td>
											<td>{{ myGlobal.ribu(ser.tarif) }}</td> 
											<td>{{ ser.tanggal }}</td> <!-- ini bulan cok -->
											<td>
												<button class="btn btn-info" @click="theGet.detail(
													ser.tanggal, ser.paket, ser.tarif, ser.ppn, ser.hDiskon, ser.tanggal_pembayaran, ser.tarif, ser.rincian1, ser.rincian2, ser.biaya1, ser.biaya2, ser.by
												)"><i class="material-icons">remove_red_eye</i> Detail</button> 
											</td>
										</tr>
										</tbody>
										<tbody v-else>
											<td></td>
											<td>Tidak ada Data</td>
										</tbody>
									</table>
								</div>
			                </div>
			              </div>
			            </div>
		        	</div>

		      		<!-- MODAL DETAIL -->
					<div class="modal" tabindex="-1" role="dialog" v-show="data.modalDetail"> <!-- data.modalDetail -->
						<div class="overlay"></div>
						<div class="modal-dialog" role="document">
							<div class="modal-content">
								<div class="modal-header">
									<h5 class="modal-title">Detail Tagihan</h5>
									<button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="data.modalDetail = false">
									  <span aria-hidden="true">&times;</span>
									</button>
								</div>
								<div class="modal-body">
									<div class="row">
										<div class="col-md-12" style="height: 450px;overflow: auto;">
											<div class="form-group">
												<div class="form-group">
													<label class="bmd-label-floating">Nama Pelanggan</label>
													<p class="form-control">{{data.namaPelanggan}}</p>
												</div>
												<div class="form-group">
													<label class="bmd-label-floating">Paket</label>
													<p class="form-control">{{cetak.form.PaketPrint}} - {{myGlobal.ribu(cetak.form.TarifPrint)}}</p>
												</div>
												<div class="form-group">
													<label class="bmd-label-floating">Bulan <span class="text-danger" v-show="bayar.form.infoShow">{{bayar.form.info}}</span></label>
													<p class="form-control">{{cetak.form.TagihanBulanPrint}}</p>
												</div>
												<div class="form-group">
													<label class="bmd-label-floating">Diskon</label>
													<p class="form-control">{{myGlobal.ribu(cetak.form.DiskonPrint)}}</p>
												</div>
												<div class="form-group">
													<label class="bmd-label-floating">Biaya Tambahan</label>
													<div class="row col-md-12">
														<p class="form-control col-md-6">{{cetak.form.Rincian1Print}}</p>
														<p class="form-control col-md-6">{{myGlobal.ribu(cetak.form.Biaya1Print)}}</p>
													</div>
													<label class="bmd-label-floating">Biaya Tambahan</label>
													<div class="row col-md-12">
														<p class="form-control col-md-6">{{cetak.form.Rincian2Print}}</p>
														<p class="form-control col-md-6">{{myGlobal.ribu(cetak.form.Biaya2Print)}}</p>
													</div>
												</div>
												<div class="form-group">
													<label class="bmd-label-floating">Admin</label>
													<p class="form-control">{{cetak.form.AdminByPrint}}</p>
												</div>
											</div>
										</div>
									</div>
								</div>
								<div class="modal-footer">
									<div v-show="data.afterBayar">
										<p>Pilih Kertas : </p>
										<small class="text-danger" v-show="cetak.form.kertasNull" >Pilih Kertas Terlebih dahulu</small>
									</div>
									<select v-model="cetak.form.kertas" class="form-control" style="width: 100px">
										<option value="" disabled selected>Pilih Kertas</option>
										<option value="POS">POS Print</option>
										<option value="A4">A4</option>
									</select>
									<button type="button" class="btn btn-info" @click="cetak.printBtn()">Print</button>
								</div>
							</div>
						</div>
					</div>
					<!-- MODEL DETAIL END -->

		      		<!-- MODAL -->
					<div class="modal" tabindex="-1" role="dialog" v-show="data.modalBayar"> <!-- data.modalBayar -->
						<div class="overlay"></div>
						<div class="modal-dialog" role="document">
							<div class="modal-content">
								<div class="modal-header">
									<h5 class="modal-title">Print Pembayaran</h5>
									<button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="data.modalBayar = false">
									  <span aria-hidden="true">&times;</span>
									</button>
								</div>
								<div class="modal-body">
									<div class="row">
										<div class="col-md-12" style="height: 450px;overflow: auto">
											<div class="form-group">
												<div class="form-group">
													<label class="bmd-label-floating">Nama Pelanggan</label>
													<input type="text" class="form-control" placeholder="Jumlah Topup..." v-model="data.namaPelanggan" disabled>
												</div>
												<div class="form-group">
													<label class="bmd-label-floating">Paket</label>
													<p class="form-control">{{data.paketPelanggan}}</p>
												</div>
												<div class="form-group">
													<label class="bmd-label-floating">Besar Iuran</label>
													<p class="form-control">{{myGlobal.ribu(data.tarifPelanggan)}}</p>
												</div>
												<div class="form-group">
													<label class="bmd-label-floating">Total Bayar</label>
													<p class="form-control">{{myGlobal.ribu(data.totalBayar)}}</p>
												</div>
												<div class="form-group">
													<label class="bmd-label-floating">Bulan Bayar</label>
													<p class="form-control">{{myGlobal.BulanOnly(data.bulanBayar)}}</p>
												</div>
												<div class="form-group">
													<label class="bmd-label-floating">Diskon</label>
													<p class="form-control">{{myGlobal.ribu(data.diskon)}}</p>
												</div>
												<div class="form-group">
													<label class="bmd-label-floating">Biaya Tambahan</label>
													<div class="row col-md-12">
														<input type="text" class="form-control col-md-6" placeholder="Rincian Baiaya 1...." v-model="data.RincianTambahan1" disabled>
														<input type="number" class="form-control col-md-6" placeholder="Biaya Tambahan 1...." v-model="data.BiayaTambahan1" disabled>
													</div>
													<label class="bmd-label-floating">Biaya Tambahan 2</label>
													<div class="row col-md-12">
														<input type="text" class="form-control col-md-6" placeholder="Rincian Baiaya 2...." v-model="data.RincianTambahan2" disabled>
														<input type="number" class="form-control col-md-6" placeholder="Biaya Tambahan 2" v-model="data.BiayaTambahan2" disabled>
													</div>
												</div>
											</div>
										</div>
									</div>
								</div>
								<div class="modal-footer">
									<div v-show="data.afterBayar">
										<p>Pilih Kertas : </p>
										<small class="text-danger" v-show="cetak.form.kertasNull" >Pilih Kertas Terlebih dahulu</small>
									</div>
									<select v-model="cetak.form.kertas" class="form-control" style="width: 100px">
										<option value="" disabled selected>Pilih Kertas</option>
										<option value="POS">POS Print</option>
										<option value="A4">A4</option>
									</select>
									<button type="button" class="btn btn-success" @click="cetak.printBtn()" v-show="!data.afterBayar">Print</button>
								</div>
							</div>
						</div>
					</div>
					<!-- MODEL END -->
					
					<div id="nota" ref="nota" v-show="false" style="width:302px;font-family: Arial;">
						<p class="title-n" style="font-size: 14pt; text-align: center;;font-family: Arial;">{{data.namaQ}}</p>
						<div class="header-content" style="width:302px;margin-top:10px;float:left;margin-bottom:10px;">
							<div class="header-box" style="width:97%;margin-left:1.5%;;margin-bottom: 10px;">
								<p style="font-size: 10pt;margin:0;font-family: Arial;"><strong>PELANGGAN</strong></p>
								<p style="font-size: 10pt;margin:0;font-family: Arial;">{{$route.params.user.unama}}</p>
								<p style="font-size: 10pt;margin:0;font-family: Arial;">{{$route.params.user.wa}}</p>
							</div>
							<div class="header-box" style="width:97%;margin-left:1.5%;;margin-bottom: 10px;">
								<p style="font-size: 10pt;margin:0;font-family: Arial;"><strong>PEMBAYARAN</strong></p>
								<p style="font-size: 10pt;margin:0;font-family: Arial;">{{'Tagihan Bulan : '+theBulan(bayar.form.bulan)}}</p>
								<p style="font-size: 10pt;margin:0;font-family: Arial;">{{'Jenis Paket : '+$route.params.user.pnama}}</p>
								<p style="font-size: 10pt;margin:0;font-family: Arial;">{{'Besar Iuran : '+$route.params.user.ptarif}}</p>
								<p style="font-size: 10pt;margin:0;font-family: Arial;" v-show="data.ppnText != 0">{{'PPN '+data.ppnText+'% : '+data.ppn}}</p>
								<p style="font-size: 10pt;margin:0;font-family: Arial;">{{'Tanggal Bayar : '+myGlobal.tglIndo(data.tglNow)}}</p>
								<p style="font-size: 10pt;margin:0;font-family: Arial;">{{'Total : '+data.totalBayar}}</p>
								<p style="font-size: 10pt;margin:0;font-family: Arial;">{{'Ket : L U N A S'}}</p>
							</div>
							<div class="header-box" style="width:97%;margin-left:1.5%;;margin-bottom: 10px;" v-if="data.RincianTambahan1 != '' || data.RincianTambahan2 != ''">
								<p style="font-size: 10pt;margin:0;font-family: Arial;"><strong>INFO BIAYA TAMBAHAN</strong></p>
								<p style="font-size: 10pt;margin:0;font-family: Arial;" v-show="data.RincianTambahan1 != ''">{{data.RincianTambahan1}}</p>
								<p style="font-size: 10pt;margin:0;font-family: Arial;" v-show="data.RincianTambahan1 != ''">{{data.BiayaTambahan1}}</p>
								<p style="font-size: 10pt;margin:0;font-family: Arial;" v-show="data.RincianTambahan2 != ''">{{data.RincianTambahan2}}</p>
								<p style="font-size: 10pt;margin:0;font-family: Arial;" v-show="data.RincianTambahan2 != ''">{{data.BiayaTambahan2}}</p>
							</div>
							<div class="header-box" style="font-size: 10pt;width:97%;margin-left:1.5%;;margin-bottom: 10px;">
								<p style="font-size: 10pt;margin:0;font-family: Arial;"><strong>INFO TAMBAHAN</strong></p>
								<p style="margin:0;font-family: Arial;">{{data.info}}</p>
							</div>
						</div>
					</div>
	        		
		    	</div>
		    </div>
</template>

<script>

import Vue from 'vue'
import vuejsDatepicker from 'vuejs-datepicker'
import moment from 'moment'
import { url } from '@/var/var.js'

import { reactive } from '@vue/composition-api'
import myGlobal from '@/globalFunc/myGlobal' 

Vue.use(moment)

export default {
  	name: 'Beranda',
	components: { 

	}, 
    setup() {
		const data = reactive({
			params: {},
			title: "Detail Servis",
			datae: [],

			modalBayar: false,
			modalDetail: false,

			/* RINCIAN PEMBAYARAN */
			namaPelanggan: '',
			paketPelanggan: '',
			telapon: '',
			tglBayar: '',
			totalBayar: '',
			ppn: 0,
			RincianTambahan1: '',
			BiayaTambahan1: 0,
			RincianTambahan2: '',
			BiayaTambahan2: 0,
			diskon: 0,
			admin: 0,
			bulanBayar: '',
			/* END RINCIAN PEMBAYARAN */
			tahunBase: '',
			tarifPelanggan: '',
			afterBayar: false,
			namaQ: '',
			tglNow: '',
			info: '',
			logo: '',
			ppn: '',
			ppnText: '',
			totalBayar: 0 // tarif + tambahan 1 + tambahan 2 + ppn
		})

		const theBulan = function(x) {
			var bulan = ['', 'Januari', 'Februari', 'Maret', 'April', 'Mei', 'Juni', 'Juli', 'Agustus', 'September', 'Oktober', 'November', 'Desember'];
			return bulan[parseInt(x)];
		}

		const theGet = {
            form: reactive({
                kodeBarang: null
            }),
			datae() {
				var datax = new FormData();
				datax.append('token', 'TangTung '+sessionStorage.getItem('myToken'));
				datax.append('id', data.params.id);
				
				var apiUrl = 'RincianUser';
				myGlobal.call(datax,apiUrl).then(x => {
					//console.log(JSON.stringify(x));
					if (x.status == "true") {
						data.datae = x.data;
					} else {
						//alert(x.pesan);
					}
				})
			},
			detail(bulan, paket, tarif, ppn, diskon, tanggal, total, rincian1, rincian2, biaya1, biaya2, by) {
				var tarifPaket = parseInt(tarif) - (parseInt(biaya1) + parseInt(biaya2)+ parseInt(ppn));
				cetak.form.UNamaPrint = data.params.user.unama;
				cetak.form.UWaPrint = data.params.user.wa;
				cetak.form.TagihanBulanPrint = bulan;
				cetak.form.PaketPrint = paket;
				cetak.form.TarifPrint = tarifPaket;
				cetak.form.PPNPrint = ppn;
				if (rincian1 != "null") {
					cetak.form.DiskonPrint = diskon;
				} else {
					cetak.form.DiskonPrint = "0";
				}
				cetak.form.TanggalPrint = tanggal;
				cetak.form.TotalPrint = total;
				if (rincian1 != "null") {
					cetak.form.Rincian1Print = rincian1;
					cetak.form.Biaya1Print = biaya1;
				} else {
					cetak.form.Rincian1Print = "-";
					cetak.form.Biaya1Print = "0";
				}
				if (rincian1 != "null") {
					cetak.form.Rincian2Print = rincian1;
					cetak.form.Biaya2Print = biaya2;
				} else {
					cetak.form.Rincian2Print = "-";
					cetak.form.Biaya2Print = "0";
				}
				cetak.form.AdminByPrint = by;
				data.modalDetail = true;
			},
			detailPrintUlang(bulan, paket, tarif, ppn, diskon, tanggal, total, rincian1, rincian2, biaya1, biaya2, by) {
				var tarifPaket = ( myGlobal.isNull(diskon) + myGlobal.isNull(tarif) ) - (myGlobal.isNull(biaya1) + myGlobal.isNull(biaya2) + myGlobal.isNull(ppn)); // di tambah diskon karena di awal sudah di kurangi diskon
				cetak.form.UNamaPrint = data.params.user.unama;
				cetak.form.UWaPrint = data.params.user.wa;
				cetak.form.TagihanBulanPrint = bulan;
				cetak.form.PaketPrint = paket;
				cetak.form.TarifPrint = tarifPaket;
				cetak.form.PPNPrint = ppn;
				if (rincian1 != "null") {
					cetak.form.DiskonPrint = diskon;
				} else {
					cetak.form.DiskonPrint = "0";
				}
				cetak.form.TanggalPrint = tanggal;
				cetak.form.TotalPrint = total;
				if (rincian1 != "null") {
					cetak.form.Rincian1Print = rincian1;
					cetak.form.Biaya1Print = biaya1;
				} else {
					cetak.form.Rincian1Print = "-";
					cetak.form.Biaya1Print = "0";
				}
				if (rincian1 != "null") {
					cetak.form.Rincian2Print = rincian2;
					cetak.form.Biaya2Print = biaya2;
				} else {
					cetak.form.Rincian2Print = "-";
					cetak.form.Biaya2Print = "0";
				}
				cetak.form.AdminByPrint = by;
			}
		}

		const bayar = {
            form: reactive({
				info: null,
				infoShow: false,
				bulan: ""
            }),
			submit() {	
				if (bayar.form.bulan == "") {
					bayar.form.infoShow = true;
					bayar.form.info = "Pilih Bulan Terlebih dulu";
					return false;
				}

				data.ppn = ( parseInt(sessionStorage.getItem('PPN')) / 100 ) * parseInt(data.params.user.ptarif);
				data.totalBayar = (parseInt(data.params.user.ptarif)+parseInt(data.BiayaTambahan1)+parseInt(data.BiayaTambahan2)+parseInt(data.ppn)) - parseInt(data.diskon);

				var datax = new FormData();
				datax.append('token', 'TangTung '+sessionStorage.getItem('myToken'));
				datax.append('id', data.params.user.uid);
				datax.append('bulan', bayar.form.bulan);
				datax.append('tahun', data.tahunBase);
				datax.append('biaya1', data.BiayaTambahan1);
				datax.append('rincian1', data.RincianTambahan1);
				datax.append('biaya2', data.BiayaTambahan2);
				datax.append('rincian2', data.RincianTambahan2);
				datax.append('diskon', data.diskon);
				
				var apiUrl = 'BayarSekarang';
				myGlobal.call(datax,apiUrl).then(x => {
					if (x.status) {
						//data.afterBayar = true;
						data.modalBayar = false;
						theGet.datae();
					} else {
					//alert(x.pesan);
					}
				})
			}
		}
		

		const modal = {
			modalBayarFunc() {
				data.modalBayar = true;
			}
		}

		const cetak = {
            form: reactive({
				kertas: "",
				kertasNull: false,

				namaQPrint: "",
				UNamaPrint: "",
				UWaPrint: "",
				TagihanBulanPrint: "",
				PaketPrint: "",
				TarifPrint: "",
				PPNPrint: "",
				DiskonPrint: "",
				TanggalPrint: "",
				TotalPrint: "",
				Rincian1Print: "",
				Rincian2Print: "",
				Biaya1Print: "",
				Biaya2Print: "",
				AdminByPrint: "",
            }),
			printBtn() {
				if (cetak.form.kertas == "") {
					cetak.form.kertasNull = true;
					return false;
				} else {
					cetak.form.kertasNull = false;
				}

				if (cetak.form.kertas == "A4") {
					cetak.printA4();
				} else {
					cetak.print();
				}
			},
			print() {
			// Pass the element id here
				data.modalBayar = false;
				

				var newWin=window.open('','Print-Window');

				newWin.document.open();

				newWin.document.write(`<html><style>@page {size:75mm auto; margin: 0mm 0mm 0mm 0mm;}</style><body style="width:75mm">
					<div id="nota" ref="nota" v-show="false" style="width:302px;font-family: Arial;">
						<p class="title-n" style="font-size: 14pt; text-align: center;;font-family: Arial;"><strong>`+data.namaQ+`</strong></p>
						<div class="header-content" style="width:302px;margin-top:10px;float:left;margin-bottom:10px;">
							<div class="header-box" style="width:97%;margin-left:1.5%;;margin-bottom: 10px;">
								<p style="font-size: 10pt;margin:0;font-family: Arial;"><strong>PELANGGAN</strong></p>
								<p style="font-size: 10pt;margin:0;font-family: Arial;">`+cetak.form.UNamaPrint+`</p>
								<p style="font-size: 10pt;margin:0;font-family: Arial;">`+cetak.form.UWaPrint+`</p>
							</div>
							<div class="header-box" style="width:97%;margin-left:1.5%;;margin-bottom: 10px;">
								<p style="font-size: 10pt;margin:0;font-family: Arial;"><strong>PEMBAYARAN</strong></p>
								<p style="font-size: 10pt;margin:0;font-family: Arial;">`+'Tagihan Bulan : '+cetak.form.TagihanBulanPrint+`</p>
								<p style="font-size: 10pt;margin:0;font-family: Arial;">`+'Jenis Paket : '+cetak.form.PaketPrint+`</p>
								<p style="font-size: 10pt;margin:0;font-family: Arial;">`+'Besar Iuran : '+myGlobal.ribu(cetak.form.TarifPrint)+`</p>
								<p style="font-size: 10pt;margin:0;font-family: Arial;" v-show="data.ppnText != 0">`+'PPN '+data.ppnText+'% : '+myGlobal.ribu(cetak.form.PPNPrint)+`</p>
								<p style="font-size: 10pt;margin:0;font-family: Arial;">`+'Diskon : '+myGlobal.ribu(cetak.form.DiskonPrint)+`</p>
								<p style="font-size: 10pt;margin:0;font-family: Arial;">`+'Tanggal Bayar : '+myGlobal.tglIndo(cetak.form.TanggalPrint)+`</p>
								<p style="font-size: 10pt;margin:0;font-family: Arial;">`+'Total : '+myGlobal.ribu(cetak.form.TotalPrint)+`</p>
								<p style="font-size: 10pt;margin:0;font-family: Arial;">`+'Ket : L U N A S'+`</p>
							</div>
							<div class="header-box" style="width:97%;margin-left:1.5%;;margin-bottom: 10px;" v-if="data.RincianTambahan1 != '' || data.RincianTambahan2 != ''">
								<p style="font-size: 10pt;margin:0;font-family: Arial;"><strong>INFO BIAYA TAMBAHAN</strong></p>
								<p style="font-size: 10pt;margin:0;font-family: Arial;" v-show="data.RincianTambahan1 != ''">`+cetak.form.Rincian1Print+`</p>
								<p style="font-size: 10pt;margin:0;font-family: Arial;" v-show="data.RincianTambahan1 != ''">`+myGlobal.ribu(cetak.form.Biaya1Print)+`</p>
								<p style="font-size: 10pt;margin:0;font-family: Arial;" v-show="data.RincianTambahan2 != ''">`+cetak.form.Rincian2Print+`</p>
								<p style="font-size: 10pt;margin:0;font-family: Arial;" v-show="data.RincianTambahan2 != ''">`+myGlobal.ribu(cetak.form.Biaya2Print)+`</p>
							</div>
							<div class="header-box" style="font-size: 10pt;width:97%;margin-left:1.5%;;margin-bottom: 10px;">
								<p style="font-size: 10pt;margin:0;font-family: Arial;"><strong>INFO TAMBAHAN</strong></p>
								<p style="margin:0;font-family: Arial;">`+data.info+`</p>
							</div>
						</div>
					</div>
				</body></html>`);

				newWin.print();

				newWin.document.close();

				setTimeout(function(){newWin.close();},10);

				//this.print();

			},
			printA4() {
			// Pass the element id here
				data.modalBayar = false;
				
				console.log(data.logo);

				var newWin=window.open('','Print-Window');

				newWin.document.open();

				newWin.document.write(`<html>
<head>
<meta charset="utf-8">
<title>Untitled Document</title>
<style>
	@page {size:210mm auto; margin: 0mm 0mm 0mm 0mm;}
	* {
		font-family: Arial, Helvetica, sans-serif;
	}
	body,html,p,h3,h2 {
		margin: 0;
		padding: 0;
	}
	.wrapper {
		margin: 10px;
		padding: 10px;
		border: 3px solid #aeaeae;
	}
	.rtrw {
		font-size: 17pt;
		color: #3498db;
	}
	.telp {
		margin-bottom: 10px;
		font-size: 14pt;
		color: #808080;
	}
	.title {
		font-size: 13pt;
		margin-bottom: 20px;
	}
	.item-title {
		padding-right: 30px;
	}
	.tanggal {
		margin-bottom: 20px;
		text-align: right;
	}
	.catatan {
		text-align: center;
		margin-top: 10px;
	}
	.gray {
		color: #808080;
		font-size: 10pt;
	}
	.header {
		color: #3498db;
		border-bottom: 1px solid #808080;
		padding: 10px 0;
	}
	.content {
		padding: 5px 0;
	}
	.logo {
		height: 60px;
		width: 60px;
	}
</style>
</head>
	
<body>
	<div class="wrapper">
		<table style="width: 100%;">
			<tr>
				<td>
					<h2 class="rtrw">`+data.namaQ+`</h2>
					<p class="title">Struk Pembayaran</p>
				</td>
				<td style="text-align:right">
					<img src="https://blonjo.web.id/beat/API/WIFI/images/`+data.logo+`" class="logo">
				</td>
			</tr>
		</table>
        	
        <div class="content">
			<table style="width: 100%;">
				<tr>
					<td>
						<div>
							<table style="width: 100%;">
								<tr>
									<th class="header">
										Deskripsi
									</th>
									<th class="header" style="text-align:right">
										Jumlah
									</th>
								</tr>
								<tr>
									<td class="content">
										`+cetak.form.PaketPrint+`
									</td>
									<td class="content" style="text-align:right">
										`+myGlobal.ribu(cetak.form.TarifPrint)+`
									</td>
								</tr>
								<tr>
									<td class="content">
										`+'PPN '+data.ppnText+`%
									</td>
									<td class="content" style="text-align:right">
										`+myGlobal.ribu(cetak.form.PPNPrint)+`
									</td>
								</tr>
								<tr>
									<td class="content">
										`+cetak.form.Rincian2Print+`
									</td>
									<td class="content" style="text-align:right">
										`+myGlobal.ribu(cetak.form.Biaya2Print)+`
									</td>
								</tr>
								<tr>
									<td class="content">
										`+cetak.form.Rincian1Print+`
									</td>
									<td class="content" style="text-align:right">
										`+myGlobal.ribu(cetak.form.Biaya1Print)+`
									</td>
								</tr>
								<tr>
									<td class="content">
										Diskon
									</td>
									<td class="content" style="text-align:right">
										`+myGlobal.ribu(cetak.form.DiskonPrint)+`
									</td>
								</tr>
								<tr>
									<th class="header">
									</th>
									<th class="header" style="text-align:right">
									</th>
								</tr>
							</table>
						</div>
					</td>
					<td style="text-align:right">
						<p class="gray">Total Iuran</p>
						<p style="font-size: 20pt;margin-bottom: 20px;color: #3498db;"><strong>`+myGlobal.ribu(cetak.form.TotalPrint)+`</strong></p>

						<p class="gray">Bayar A.n.</p>
						<p style="font-size: 16pt;">`+data.params.user.unama+`</p>
						<p style="font-size: 16pt;margin-bottom: 20px;">`+data.params.user.wa+`</p>

						<p class="gray">Tagihan Bulan</p>
						<p style="margin-bottom: 20px;">`+cetak.form.TagihanBulanPrint+`</p>

						<p class="gray">Tanggal</p>
						<p style="margin-bottom: 20px;">`+myGlobal.tglIndo(cetak.form.TanggalPrint)+`</p>
					</td>
				</tr>
			</table>
		</div>
        <p class="catatan">`+data.info+`</p>
	</div>
</body>
</html>
				`);

				newWin.print();

				// newWin.document.close(); 

				// setTimeout(function(){newWin.close();},10);

				//this.print();

			}
		}

        return {
            myGlobal,
			data,
			theBulan,
			theGet,
			modal,
			cetak,
			bayar
		}
	},
    mounted () {
		// kalo disini pake this
		this.data.params = this.$route.params;

		//console.log(JSON.stringify(this.data.params.user));

		this.theGet.datae();

			/* RINCIAN PEMBAYARAN */
		this.data.namaPelanggan = this.$route.params.user.unama;
		this.data.paketPelanggan = this.$route.params.user.pnama;
		this.data.telapon = this.$route.params.user.wa;
		this.data.tglBayar = this.$route.params.user.hbayar_tanggal;
		this.data.totalBayar = this.$route.params.user.paket_tarif;
		this.data.ppn = this.$route.params.user.ppn;
		this.data.RincianTambahan1 = this.$route.params.user.rincian1 == "null" ? "-" : this.$route.params.user.rincian1;
		this.data.BiayaTambahan1 = this.$route.params.user.biaya1 == "null" ? "0" : this.$route.params.user.biaya1;
		this.data.RincianTambahan2 = this.$route.params.user.rincian2 == "null" ? "-" : this.$route.params.user.rincian2;
		this.data.BiayaTambahan2 = this.$route.params.user.biaya2 == "null" ? "0" :this.$route.params.user.biaya2;
		this.data.diskon = this.$route.params.user.diskon;
		this.data.admin = this.$route.params.user.by_admin;
		this.data.bulanBayar = this.$route.params.user.htanggal;
		this.data.tarifPelanggan = this.$route.params.user.tarif;

		this.theGet.detailPrintUlang(
			myGlobal.BulanOnly(this.data.bulanBayar),
			this.data.paketPelanggan,
			this.data.totalBayar,
			this.data.ppn,
			this.data.diskon,
			this.data.tglBayar,
			this.data.totalBayar,
			this.data.RincianTambahan1,
			this.data.RincianTambahan2,
			this.data.BiayaTambahan1,
			this.data.BiayaTambahan2,
			this.data.admin,
		);
			/* END RINCIAN PEMBAYARAN */

		this.data.namaQ = sessionStorage.getItem('admin');
		
		var date = new Date();
		this.data.tglNow = moment(date).format('YYYY-MM-DD');

		this.data.info = sessionStorage.getItem('myInfoPrint');
		this.data.logo = sessionStorage.getItem('logo');

		this.data.ppnText = sessionStorage.getItem('PPN');
		
    	this.data.tahunBase = myGlobal.getTahunNow();
    }
}
/*
export default {
	components: { 
		vuejsDatepicker,
		moment,
	}, 
	methods: {,
	},
	mounted() {
	}
}
*/
</script>

<style scoped>
p {
	margin: 0 !important;
}
.edit-input {
	font-size: 20pt !important;
}
.modal {
	display: inherit;
}
.overlay {
	position:fixed;
	top:0;bottom:0;right:0;left:0;
	background-color: rgba(0,0,0,0.5);
}
</style>


// WEBPACK FOOTER //
// src/components/pelanggan-lunas/detail.vue